import { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Drawer from '@material-ui/core/Drawer';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/Close';
import HomeIcon from '@material-ui/icons/Home';
import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';
import PhotoLibraryIcon from '@material-ui/icons/PhotoLibrary';

import Constants from '../../utils/Constants';
import { useNavigate } from 'react-router-dom';
import useAuthentication from '../../hooks/useAuthentication';
import { isManager } from '../../utils/AuthUtils';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
}));


const Menu = (props) => {
  const classes = useStyles();
  const navigate = useNavigate();
  
  const [ isAuthenticated, logout ] = useAuthentication();
  const [ isMenuOpen, setIsMenuOpen] = useState(false);

  let handleClick_menuItem_logout = () => {
    logout();
    
    // Logout and force the page to reload, this will ensure that the
    // Layout and authentication hooks get the correct authentication 
    // state and redirect the user to the login page.
    window.location.reload(); 
  }

  let handleClick_menuItemNavigate = (routePath) => {
    navigate(routePath);
    setIsMenuOpen(false);
  }

  let handleHamburger = (event) => {
    if (!isMenuOpen) { // Menu is curently closed
      setIsMenuOpen(true);
    } else {
      setIsMenuOpen(false);
    }
  }
  
  const renderMenuItems = () => {
    if (!isAuthenticated) {
      return null;
    }

    let isErmaManager = isManager();
    return (
      <>
        <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu" onClick={ handleHamburger }>
          <MenuIcon />
        </IconButton>
        <Drawer anchor="left" open={isMenuOpen} onClose={handleHamburger}>
          <div style={{width: '250px'}}>
            <ListItem button key="mnuClose" onClick={handleHamburger} style={{flexDirection: 'row-reverse'}}>
              <ListItemIcon style={{minWidth: '24px', width: '30px'}}><CloseIcon /></ListItemIcon>
            </ListItem>
            <ListItem button key="mnuHome" onClick={() => handleClick_menuItemNavigate(Constants.RoutePath.Inventory.List)}>
              <ListItemIcon><HomeIcon /></ListItemIcon>
              <ListItemText primary="Home" />
            </ListItem>
            { 
              isErmaManager === false ? null : (
                <ListItem button key="mnuGallery" onClick={() => handleClick_menuItemNavigate(Constants.RoutePath.Gallery.View)}>
                  <ListItemIcon><PhotoLibraryIcon /></ListItemIcon>
                  <ListItemText primary="Gallery" />
                </ListItem>
              )
            }
            <Divider />
            <ListItem button key="mnuLogout" onClick={handleClick_menuItem_logout}>
              <ListItemIcon><MeetingRoomIcon /></ListItemIcon>
              <ListItemText primary="Logout" />
            </ListItem>
          </div>
        </Drawer>
      </>
    );
  }

  return (
    <div>
      <AppBar position="static">
        <Toolbar>
          { renderMenuItems() }
          <Typography variant="h6" className={classes.title}>
            ERMA Inventory
          </Typography>
          { !isAuthenticated ? <Button color="inherit" href={Constants.RoutePath.Login}>Login</Button> : null }
        </Toolbar>
      </AppBar>
    </div>
  );
}

export default Menu;
